const USA = 'Estados Unidos';
const URSS = 'URSS';

const Missions = [
  {
    name: 'Apollo 11',
    year: '1960',
    country: USA,
    destination: 'Lua',
  },
  {
    name: 'Voyager 1',
    year: '1977',
    country: USA,
    destination: 'Espaço interestelar',
  },
  {
    name: 'Mars Pathfinder',
    year: '1996',
    country: USA,
    destination: 'Marte',
  },
  {
    name: 'Estação Internacional Espacial',
    year: '1998',
    country: 'Estados Unidos e Rússia',
    destination: 'Órbita terrestre',
  },
  {
    name: 'Kepler',
    year: '2009',
    country: USA,
    destination: 'Espaço interestelar',
  },
  {
    name: 'Cassini-Huygens',
    year: '2009',
    country: 'Estados Unidos e União Europeia',
    destination: 'Saturno',
  },
  {
    name: 'Mariner 2',
    year: '1962',
    country: USA,
    destination: 'Vênus',
  },
  {
    name: 'Venera 4',
    year: '1967',
    country: URSS,
    destination: 'Vênus',
  },
  {
    name: 'Mariner 5',
    year: '1967',
    country: USA,
    destination: 'Vênus',
  },
  {
    name: 'Mariner 10',
    year: '1975',
    country: USA,
    destination: 'Vênus',
  },
  {
    name: 'Venera 16',
    year: '1983',
    country: URSS,
    destination: 'Vênus',
  },
  {
    name: 'MESSENGER',
    year: '2004',
    country: USA,
    destination: 'Mercúrio',
  },
  {
    name: 'Genesis',
    year: '2001',
    country: USA,
    destination: 'Terra',
  },
  {
    name: '2001 Mars Odyssey',
    year: '2001',
    country: USA,
    destination: 'Marte',
  },
  {
    name: 'Mars Surveyor 98 Lander',
    year: '1999',
    country: USA,
    destination: 'Marte',
  },
  {
    name: 'Nozomi (Planeta B)',
    year: '1998',
    country: 'Japão',
    destination: 'Marte',
  },
  {
    name: 'Fobos 1',
    year: '1988',
    country: URSS,
    destination: 'Marte',
  },
  {
    name: 'Fobos 2',
    year: '1988',
    country: URSS,
    destination: 'Marte',
  },
  {
    name: 'Galileo',
    year: '1989',
    country: USA,
    destination: 'Júpiter',
  },
  {
    name: 'Cassini/Huygens',
    year: '1997',
    country: 'Estados Unidos e Europa',
    destination: 'Saturno',
  },
];

export default Missions;
